import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { underwritingQueueService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseUnderwritingUnclaimMutationProps = {
	id: string;
	onSuccessHandler?: Function;
};

const useUnderwritingUnclaimMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: UseUnderwritingUnclaimMutationProps) => {
			dispatch(uiActions.showSpinnerOverlay());

			return underwritingQueueService.unclaimToCurrentUser({ id });
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess(data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Claim has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUnderwritingUnclaimMutation;
